var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19H70V60C70 65.5228 65.5229 70 60 70H10C4.47715 70 0 65.5228 0 60V19Z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.47715 4.47715 0 10 0H60C65.5229 0 70 4.47715 70 10V21H0V10ZM24 8.50006C24 11.2615 21.7614 13.5001 19 13.5001C16.2386 13.5001 14 11.2615 14 8.50006C14 5.73864 16.2386 3.50006 19 3.50006C21.7614 3.50006 24 5.73864 24 8.50006ZM52.25 13.5001C55.0114 13.5001 57.25 11.2615 57.25 8.50006C57.25 5.73864 55.0114 3.50006 52.25 3.50006C49.4886 3.50006 47.25 5.73864 47.25 8.50006C47.25 11.2615 49.4886 13.5001 52.25 13.5001Z",
    fill: "#FF4646"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 48,
    r: 4,
    fill: "#D4D4D4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 48,
    r: 4,
    fill: "#D4D4D4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 48,
    r: 4,
    fill: "#D4D4D4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 32,
    r: 4,
    fill: "#FF4646"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 32,
    r: 4,
    fill: "#FF4646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 33.28L18.975 26.455H21.225L17.535 33.28H15.375ZM15.375 34.48V33.28L16.125 32.695H23.685V34.48H15.375ZM20.355 37V30.28H22.365V37H20.355Z",
    fill: "#FF4646"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 3,
    width: 48,
    height: 11,
    fill: "#FF4646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadRequest);
export default __webpack_public_path__ + "static/media/badRequest.20dcc75f2bf1328e9b26c4860b83536b.svg";
export { ForwardRef as ReactComponent };